import styled from "@emotion/styled";
import { hideScrollbar } from "src/scrollbar";

export const SizesListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space.space24};
  max-height: 348px;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  padding: 16px 0;
  ${hideScrollbar}

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    max-height: 100%;
  }
`;

export const SizeList = styled.section`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space.space8};
`;

export const SizesWrapper = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.space8};
  grid-auto-rows: minmax(0, ${({ theme }) => theme.space.space48});

  &.small {
    grid-template-columns: repeat(auto-fill, minmax(44px, 1fr));
    @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &.large {
    grid-template-columns: repeat(4, 1fr);
    @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  &.xlarge {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const SizeListTitle = styled.span`
  font-size: ${({ theme }) => theme.fontSizes?.fontSize16};
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.tone.black};
`;

export const StyledSizeButton = styled.button<{ $scale?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 0;

  padding-block: ${({ theme }) => theme.space.space8};
  padding-inline: ${({ theme }) => theme.space.space16};
  background-color: ${({ theme }) => theme.colors.tone.white};
  border: 1px solid #ddd;
  border-radius: ${({ theme }) => theme.space.space4};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.tone.black};

  &:hover {
    background-color: ${({ theme }) => theme.colors.tone.sand};
  }

  &.active {
    border-color: ${({ theme }) => theme.colors.tone.black};
    border-width: 2px;
  }
`;

export const SizeSchemaTabs = styled.div`
  display: flex;
  column-gap: ${({ theme }) => theme.space.space24};
  overflow-x: auto;
  white-space: nowrap;
  position: relative;
  border-bottom: 1px solid #eee;
  border-radius: 4px;
  background: var(--Tones-White, #fff);
  ${hideScrollbar}
`;

export const SizeSchemaTab = styled.button`
  font-family: "PlusJakartaSans", sans-serif;
  font-size: ${({ theme }) => theme.fontSizes?.fontSize16};
  line-height: ${({ theme }) => theme.fontSizes.fontSize24};
  color: ${({ theme }) => theme.colors?.tone.anthracite};
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding-bottom: ${({ theme }) => theme.space.space8};

  &.active {
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.tone.black};
  }

  &.active::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    background: ${({ theme }) => theme.colors?.tone.black};
  }
`;
